import axios from "axios";

const useDeleteHandler = (url, fetchData, setShowDelete) => async (id) => {
  console.log("url", url);
  console.log("fetchData", fetchData);
  console.log("setShowDelete", setShowDelete);
  try {
    await axios.delete(`${process.env.REACT_APP_API_URL}${url}/delete/${id}`);
    fetchData();
    setShowDelete(false);
  } catch (err) {
    console.error(err);
  }
};

export default useDeleteHandler;
